(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('ConcurrentReviewFrequencyController', ConcurrentReviewFrequencyController);

    ConcurrentReviewFrequencyController.$inject = ['ConcurrentReviewFrequency', 'GUIUtils', 'CoreService',
        'GenericEntityDatatableService', '$uibModal', 'ConfirmationService', '$q'];

    function ConcurrentReviewFrequencyController(ConcurrentReviewFrequency, GUIUtils, CoreService,
                                                 GenericEntityDatatableService, $uibModal, ConfirmationService, $q) {
        var vm = this;

        var params = CoreService.getFilterByCurrentCorporation();

        vm.descriptor = {
            title: 'Concurrent Review Frequencies',
            entityClassHumanized: 'Concurrent Review Frequencies',
            entityStateName: 'concurrent-review-frequency',
            service: ConcurrentReviewFrequency,
            serviceMethod: 'findAllByCorporation',
            params: params,
            newAction: false,
            options: [{key: 'aaSorting', value: [[1, 'asc'], [0, 'asc']]}],
            columns: [
                {
                    name: 'name',
                    title: 'Name'
                },
                {
                    name: 'days',
                    title: 'Frequency',
                    render: function (data) {
                        return GUIUtils.weekCodeStringToDays(data.days);
                    }
                }
            ],
            rowActions: [
                angular.extend({}, GenericEntityDatatableService.getEditAction(), {
                    action: function (data) {
                        return edit(data.id);
                    }
                }),
                angular.extend({}, GenericEntityDatatableService.getDeleteAction(), {
                    action: function (data) {
                        return del(data.id);
                    }
                }),
            ],
            actions: [
                {
                    type: 'group',
                    buttons: [
                        angular.extend({}, GenericEntityDatatableService.getNewAction(), {
                            name: 'New Frequency',
                            action: function () {
                                return add();
                            }
                        })
                    ]
                }
            ],
        }

        function add() {
           return $uibModal.open({
                templateUrl: 'app/entities/concurrent-review-frequency/update/concurrent-review-frequency-dialog.html',
                controller: 'ConcurrentReviewFrequencyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowTopClass: 'custom-dialog-styles',
                size: 'md',
                resolve: {
                    entity: ['CoreService', function (CoreService) {
                        return {
                            name: null,
                            days: null,
                            id: null,
                            corporation: CoreService.getCorporation()
                        };
                    }]
                }
            }).result;
        }

        function edit(id) {
            return $uibModal.open({
                templateUrl: 'app/entities/concurrent-review-frequency/update/concurrent-review-frequency-dialog.html',
                controller: 'ConcurrentReviewFrequencyDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                windowTopClass: 'custom-dialog-styles',
                resolve: {
                    entity: ['ConcurrentReviewFrequency', function (ConcurrentReviewFrequency) {
                        return ConcurrentReviewFrequency.get({id: id}).$promise;
                    }]
                }
            }).result;
        }

        function del(id) {
            return $q(function (resolve) {
                ConfirmationService.showDelete('Concurrent Review Frequency').result.then(function () {
                    ConcurrentReviewFrequency.delete({id: id}, function () {
                        return resolve();
                    });
                })
            });
        }
    }
})();
